<template>
  <div>
    <NavBar />
    <NewRouteOfAdministration @created="getRoutesOfAdministration()" />
    <ViewRouteOfAdministration
      :route_of_administration_id="route_of_administration_id"
      @updated="getRoutesOfAdministration()"
    />
    <b-overlay :show="loading" opacity="0.99">
      <div class="container">
        <v-card>
          <v-card-title>
            <div class="col-auto">
              <v-btn
                class="v-primary mb-1"
                @click="$bvModal.show('new_route_of_administration')"
              >
                <span class="fa fa-plus"></span> Novo
              </v-btn>
            </div>
            <div class="col">Vias de administração</div>
            <div class="col">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              />
            </div>
          </v-card-title>
          <v-card-text>
            <ErrorsMessages :errors="errors" />
            <div class="col">
              <v-data-table
                dense
                :headers="headers"
                :items="routesOfAdministration"
                :search="search"
                :footer-props="{
                  'items-per-page-options': [25, 75, 100],
                  'items-per-page-text': 'Mostrar',
                }"
                @click:row="openViewModal"
              >
              </v-data-table>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import NewRouteOfAdministration from "../templates/care/route-of-administration/NewRouteOfAdministration";
import ViewRouteOfAdministration from "../templates/care/route-of-administration/ViewRouteOfAdministration";

import ErrorsMessages from "../templates/components/ErrorsMessages";

import api from "../services/api";

import { formatDate } from "../functions/format";
import { adminData } from "../lib/functions";

export default {
  name: "RouteOfAdministration",
  components: {
    NavBar,
    NewRouteOfAdministration,
    ViewRouteOfAdministration,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],

      loading: false,

      search: "",
      headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Via de administração", value: "name" },
      ],
      routesOfAdministration: [],
      route_of_administration_id: "",
    };
  },
  created() {
    this.permissions = adminData().permissions;

    this.getRoutesOfAdministration();
  },
  methods: {
    formatDate,
    async openViewModal(item) {
      this.route_of_administration_id = item.id;
      this.$bvModal.show("view_route_of_administration");
    },
    async getRoutesOfAdministration() {
      try {
        this.loading = true;

        let response = await api.get("/admin/care/routes-of-administration");
        let { error, errors, routes_of_administration } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.routesOfAdministration = routes_of_administration;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>